'use strict'

define ['./sendApplicationLinkModal.scss'], () ->
  ($scope, $rootScope, $uibModalInstance, ApplicationTemplate, $cacheFactory) ->
    $scope.apptemp_link = "#{$rootScope.HOST}/#{$scope.apptemp.slug}?a=#{btoa($rootScope.user.username)}"
    $scope.theme_color = $rootScope.THEME_COLOR
    $scope.is_loading = false

    $scope.show_report = (apptemp, report_type) ->
      _.find(apptemp.landlord.report_source_profiles, {'short_label': report_type})

    # Default Email Content
    $scope.email_content =
      subject: 'Rental Application Link'
      body: ''
      form_url: "#{$rootScope.HOST}/#{$scope.apptemp.slug}/"

    $scope.toggle_cc = () ->
      $scope.email_content.cc_myself = !$scope.email_content.cc_myself

    $scope.send_link = (email_content) ->
      $scope.is_loading = true
      # Remapping cc_myself before sending POST data
      if $scope.email_content.cc_myself
        $scope.email_content.cc_myself = "on"

      ApplicationTemplate.send_invitation({ id: $scope.apptemp.id }, $scope.email_content).$promise
        .then (response) ->
          if response.result != 'success'
            # Show Error
            console.log(response)
          else
            # close
            $uibModalInstance.close($scope.email_content)
        .catch (error) ->
          # Show Error
          console.log(error)
        .finally ->
          $scope.is_loading = false



// WEBPACK FOOTER //
// ./directives/sendApplicationLink/sendApplicationLinkModal/sendApplicationLinkModal.coffee